import { FormProvider, useForm } from "react-hook-form";
import { getRenewalAdvisories } from "./lookup/advisories";
import { Renewal } from "@/api/williams/renewals";
import { RenewalForm } from "./RenewalForm";
import { RenewalFormWelders } from "./RenewalFormWelders";
import { RenewalSchema } from "./RenewalSchema";
import { SavePrompt } from "@/components";
import { SpinButton } from "@/components/form/SpinButton";
import { useAddRenewal, useWelderAdvisories } from "./hooks";
import { useLoadingScreen } from "@/hooks";
import { useLocation } from "react-router-dom";
import { Warning } from "../components/alerts";
import { Welder } from "@/api/williams/welders";
import { zodResolver } from "@hookform/resolvers/zod";

export function WelderRenewal() {
  const { state } = useLocation();
  const submit = useAddRenewal();
  const loader = useLoadingScreen();

  const form = useForm<Renewal>({
    resolver: zodResolver(RenewalSchema),
    reValidateMode: "onChange",
    defaultValues: {
      process: state?.process,
      technique: state?.technique,
      welders: state?.welders?.map((welder: Welder) => ({
        name: welder.name,
        welderId: welder.welderId,
        update: true,
        reinstatement: false,
      })),
    },
  });

  const data = form.watch();
  const advisories = getRenewalAdvisories(data);
  const welderAdvisories = useWelderAdvisories(data);
  const isDirty = Object.keys(form.formState.dirtyFields).length > 0;

  function handleAddRenewal(renewal: Renewal) {
    loader.show();
    submit.mutate(renewal);
  }

  return (
    <SavePrompt when={isDirty}>
      <div style={{ maxWidth: 1000 }} className="mb-5">
        <h3>Add Renewal</h3>
        <FormProvider {...form}>
          <RenewalForm locked={loader.visible} />
          <RenewalFormWelders initialWelders={state?.welders} />

          {welderAdvisories.data?.map((advisory, index) => (
            <Warning key={index}>{advisory}</Warning>
          ))}
          {advisories.map((advisory, index) => (
            <Warning key={index}>{advisory}</Warning>
          ))}

          <SpinButton
            type="button"
            className="btn btn-default mt-2"
            hidden={!data.welders || data.welders.length === 0}
            disabled={loader.visible}
            onClick={form.handleSubmit(handleAddRenewal)}
          >
            Update Welder(s)
          </SpinButton>
        </FormProvider>
      </div>
    </SavePrompt>
  );
}
